module.exports = __webpack_public_path__ + "img/s-unfold.28cfd743.svg";